<template>
    <HvvContainer />
</template>

<script>
    import HvvContainer from './components/HvvContainer.vue'

    export default {
        name: 'App',
        components: {
            HvvContainer,
    }
}
</script>

<style lang="scss">
    // Import Main styles for this application
    @import 'assets/scss/style';
 
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
